<template>
<div>
  <color-modal @update="closeColorModal" />
  <div class="card border-info" >
    <div v-if="msg" class="card-text alert alert-danger">
      <strong>{{msg}}</strong>
    </div>
    <div class="card-header bg-transparent border-info">
    <p><i style="color:blue" class="fas fa-palette mr-2" aria-hidden="true"></i><strong>TABELLA COLORI</strong></p> 
         <button  @click="newColor()" type="button" class="btn-success  btn-sm float-right">
           <i class="fas fa-plus-circle mr-2" aria-hidden="true"></i>
           NUOVO</button>
    </div>
    <div class="card-body"> 


    
    <div class="table-wrapper-scroll-y my-custom-scrollbar">
      <div v-if="!spinner">   
      <table class="table table-hover table-sm" id="table">
        <thead style='color : navy'>
        <tr>
          <th> <i class="fa fa-check-square" aria-hidden="true"></i></th>    
          <th>ID</th>        
          <th>COLORE</th>   
        </tr>
        </thead>
        <tbody>
        <tr @click="toggleRow(item)" v-for="(item, index) in filteredColors" :key="index">
          <td>    
            <input class="pointer"  type="checkbox" :v-bind-value="item.selected" v-model="item.selected" :disabled="true">
          </td>    
          <td>{{item.colorId}}</td>
          <td v-bind:class="{ 'selected': item.selected }">{{item.color}}</td>
        </tr>
        </tbody>
      </table>
    </div>
      <div v-else>
      <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Loading...</span>
      </div>
    </div>    
    </div>
    <strong>Filtra colore</strong> <input class="form-control" type="text" name="query" v-model="filterKey">
   
    </div>
    </div> 
  <small  id="colorHelp" class="form-text text-muted"><strong>Selezionare un colore dall'elenco.</strong></small> 
  </div>
</template>

<script>

import colorModal                from '@/components/common/ColorModal.vue';
import { mapGetters } from 'vuex';
import api from '@/api'
  export default {
  props : ['selection'],
  components: {colorModal},
    data () {
      return {
        
        colors       : [],
        filterKey    : '',
      
        msg          : '',
        
        spinner      : false,
        
                     
      }
    },
    watch :
    {

    },
    
  
    computed: {
    ...mapGetters(['company']),
      filteredColors : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.colors
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     }
     
      
      
    },
    mounted()
    {   
     
    },
    created () 
      {
       
        this.getData()
      },
    methods: 
    {
      newColor()
      {
              
        $('#colorModal').on('shown.bs.modal', function (e) {
        $('#inputColor').val('')
        $('#inputColor').trigger('focus');

      })
        $('#colorModal').modal({keyboard: false,backdrop:'static'});
      },
    
      closeColorModal()
      {
        $('#colorModal').modal('hide');
        this.getData()
      },
      toggleRow(row)  
      {

          
          
          if(row.disabled)
          {
            return
          }
                  
          //return
          
          var arr = []
          var type = row.selected
          
          row.order_by = Date.now()
                    
          this.colors.forEach(item=>{
              if(item.colorId == row.colorId)
              {   
                  item.selected = type == false ? true : false
                  
              }
          })
         
          this.colors.forEach(item => {

            if(item.selected)
            { 
          
              arr.push(item)
          
            }
          
        })
        
        
        arr.sort((a, b) => a.order_by - b.order_by);
        
        

        this.$emit('update',arr)

      },
      async getData()
      {

        this.spinner = true
        var data = {'companyId'  : this.company.Id}
        var sp   = {'sp'         : 'spColorList'}
        var json     = Object.assign(data, sp)

        await api.post(json).then(res => {
          if(res.status==200)
            {

              //console.log(this.selection)
              
              this.colors = res.data.recordsets[0]
              

              this.selection.forEach(item=>{
                this.colors.forEach(color=>{
                if(item.colorId == color.colorId)
                {
              
                  color.selected = true
                  if(item.disabled==true)
                  {
                    color.disabled = true
                  }
              
                }
                
                })
              })
                 
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)  

        }).finally(() => {
          this.spinner = false
        });


        

  
      },
      
      

      
      

    }
  }
</script>
<style scoped>

p {
  font-family   : 'Roboto Condensed';
  font-size     : 18px;
}

.selected
{
  color        : red;  
  font-family  : 'Roboto Condensed';
  font-weight  : bold;
  
  
}
.green{
  background-color : #41B883;
}

tr {
    cursor: pointer;
} 
.pointer:hover
{
  _background-color: blue;
  _color: white;
  cursor: pointer;
}
 
  .my-custom-scrollbar {
    position  : relative;
    height    : 200px;
    overflow  : auto;
    }
  .table-wrapper-scroll-y {
    display   : block;
  }
  
.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

  h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}

</style>
